import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Row, Col, Image } from 'antd'
import ViewContainer from './container'
import { BBTabs } from 'components/Tabs'
const Styled = styled.div`

  .img-absolute {
    position: absolute;
  }
  .bonanza-banner-wrapper {
    position: absolute;
    z-index: 2;
  }
  .right-0 {
    right: 0;
  }

  @media (max-width: 576px) {
    .img-absolute, .bonanza-banner-wrapper {
      display: none;
    }
  }
`

export default function Index({ defaultKey, setIsLoading, withImage = true, superCardImage = '', showBonanzaBanner }) {
  return (
    <>
      <ViewContainer defaultKey={defaultKey} setIsLoading={setIsLoading}>
        {({ tabs, onChangeBBTabs }) => (
          <Styled>
            <Row>
              <Col
                xs={{ span: 24, offset: 0 }}
                sm={{ span: 24, offset: 0 }}
                md={{ span: 22, offset: 1 }}
                lg={{ span: 22, offset: 1 }}
                xl={{ span: 22, offset: 1 }}
                className='mt-4'
              >
                <BBTabs tabs={tabs} defaultActiveKey={defaultKey !== '' ? defaultKey : 'my'} onChange={onChangeBBTabs} />
              </Col>
            </Row>
          </Styled>
        )}
      </ViewContainer>
    </>
  )
}

Index.propTypes = {
  setIsLoading: PropTypes.any,
  defaultKey: PropTypes.string,
  withImage: PropTypes.bool,
  superCardImage: PropTypes.string,
  showBonanzaBanner: PropTypes.bool
}
